import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Salvaged from ui-sprocket src/components/BrandMark.tsx — reviewed 2026-09-21: the tenant
// hook is gone — the workspace name is a prop, so the mark is usable in both shells and the
// playground; sizes unchanged.
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/material/styles';
import { RADIUS } from '../tokens/radius.js';
import { rem } from '../tokens/type.js';
const TEETH = [0, 45, 90, 135, 180, 225, 270, 315];
/**
 * The sprocket: a ring, eight teeth and a hub, drawn in the current text colour so it
 * sits on any brand tile. Scales to whatever box it is given.
 */
export function SprocketGlyph({ size = 16 }) {
    return (_jsxs("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true", focusable: "false", children: [_jsx("circle", { cx: "12", cy: "12", r: "6.1", stroke: "currentColor", strokeWidth: "2.7" }), _jsx("g", { fill: "currentColor", children: TEETH.map((angle) => (_jsx("rect", { x: "10.8", y: "1.4", width: "2.4", height: "4.4", rx: "1", transform: `rotate(${angle} 12 12)` }, angle))) }), _jsx("circle", { cx: "12", cy: "12", r: "1.7", fill: "currentColor" })] }));
}
/**
 * Brand lockup: the sprocket on a solid tile in the primary colour, plus the workspace
 * name. No gradient and no initial-in-a-box — one mark for every workspace, coloured by
 * the workspace (§9). `onBrand` is for surfaces already painted in the brand colour (the
 * sign-in pane): the tile turns translucent and the type takes the contrast colour.
 */
export function BrandMark({ name, size = 'md', nameless = false, onBrand = false, }) {
    const dim = size === 'sm' ? 26 : size === 'md' ? 32 : 40;
    const glyph = size === 'sm' ? 16 : size === 'md' ? 19 : 24;
    const fontSize = size === 'sm' ? rem(14) : size === 'md' ? rem(17) : rem(20);
    return (_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: size === 'sm' ? 1.25 : 1.5, minWidth: 0 }, children: [_jsx(Box, { sx: (theme) => ({
                    width: dim,
                    height: dim,
                    borderRadius: `${size === 'sm' ? RADIUS.sm + 1 : RADIUS.md + 1}px`,
                    display: 'grid',
                    placeItems: 'center',
                    flexShrink: 0,
                    color: theme.palette.primary.contrastText,
                    bgcolor: onBrand
                        ? alpha(theme.palette.primary.contrastText, 0.16)
                        : theme.palette.primary.main,
                }), children: _jsx(SprocketGlyph, { size: glyph }) }), !nameless && (_jsx(Typography, { component: "span", sx: (theme) => ({
                    fontWeight: 600,
                    letterSpacing: '-0.01em',
                    fontSize,
                    lineHeight: 1.2,
                    color: onBrand ? theme.palette.primary.contrastText : 'inherit',
                }), noWrap: true, children: name }))] }));
}
//# sourceMappingURL=brand-mark.js.map